<template>
    <div class="" style="padding:.2rem 0 8rem 0">

        <div class="order-success">
            <div class="icon"></div>
            <div class="title">报名成功</div>
            <img src="data:image/png;base64,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" />
            <p>扫码加工作人员好友，进入赛事微信群</p>
        </div>


            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="单位"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        title="队伍"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        title="赛区"
                        value="1"
                />

            </van-cell-group>

        <div class="sai-shuo-li">
            <img src="http://thirdwx.qlogo.cn/mmopen/22YD2oBcVUaWoEVM4r6FVevyBwOStWnB4BrL8kY6gzhXpbib5XavEIbfPMibd3y7NLjpVrwNbqFc9K1pZJWXJibXaa7ESBRceAT/132" />

            <div class="fr">
                <div class="btn">
                    立即进入
                </div>
            </div>
            <div class="c">
                <div class="title">
                    2019-2020年全国啦啦操联赛（清华大学站）
                </div>
                <div class="desc">
                    更多精彩，进去赛事专区
                </div>
            </div>
            <div class="clear"></div>
        </div>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .order-success{
        text-align: center;
        margin: 20px 0 ;
    }
    .order-success .icon{
        background: url(../../../assets/images/icon-order-done.png);
        background-size: 100%;
        width: 75px;
        height: 75px;
        margin: 20px auto 20px auto;

    }
    .order-success .title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
    }
    .order-success img{
        width: 120px;
        height: 120px;
        margin: 10px auto;
    }
    .order-success p{
        font-size: 12px;
        color: #999;
    }

    .sai-shuo-li{
        background: #f3f3f3;
        border-radius: 10px;
        margin: 20px 10px ;
        padding: 10px;
    }
    .sai-shuo-li img{
        width: 50px;
        height: 50px;
        border-radius: 6px;
        float: left;
        margin-right: 10px;
    }
    .sai-shuo-li .c{
        width: calc(100% - 80px);
        border-right: 1px solid #00000008 ;
    }
    .sai-shuo-li .c .title{
        font-size: 14px;
        color: #000;
    }
    .sai-shuo-li .c .desc{
        font-size: 12px;
        color: #999;
    }
    .sai-shuo-li .fr{
        width: 70px;
        float: right;
    }
    .sai-shuo-li .btn{
        width: 60px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        text-align: center;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:6px;
        color: #fff;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }



</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                roomTypeColumns: ['标间', '单人间'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                subjectArray:[],
                subjectOptions:[],
                subjectOptionsAll: [
                    {
                        name: '幼儿组',
                        children: [
                            {
                                name: '幼儿组',
                                children: [{ name: '舞蹈啦啦操',
                                    children:[
                                        {
                                            name: '花球规定动作',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ] }, {
                                    name: '余杭区',
                                    children:[
                                        {
                                            name: '111',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ]
                                }],
                            },
                            {
                                name: '温州',
                                children: [{ name: '鹿城区' }, { name: '瓯海区' }],
                            },
                        ],
                    },
                    {
                        name: '福建',
                        children: [
                            {
                                name: '福州',
                                children: [{ name: '鼓楼区' }, { name: '台江区' }],
                            },
                            {
                                name: '厦门',
                                children: [{ name: '思明区' }, { name: '海沧区' }],
                            },
                        ],
                    },
                ],
                formData: {
                    id: 0,
                    saiqu_name:'xxxxx',
                    danwei:'xxxxx',
                    caipan:[],
                    music:[],
                    famliy:[],
                    tbydy:[],
                    jiaolian:[],
                    member:[],
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onMemberConfirm(values){
                console.log('onMemberConfirm',values)
                this.showMemberPicker = false;
                this.formData.member = [...values];
            },
            onMemberChange(values){
                console.log('onMemberChange',values)
                this.formData.member = [...values];
            },
            onRoomTypeConfirm(value, index){
                this.formData.roomTypeName = value;
                this.formData.roomtype = index+1;
                this.showRoomTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (that.formData.changdipic.length == 0) {
                        Toast('请上传场地照片');
                        return
                    }
                    if (that.formData.zhizhaopic.length == 0) {
                        Toast('请上传单位执照');
                        return
                    }
                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                if (that.submitType =='save') {
                    that.$api.post('/api/examecenter/save', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                } else {
                    that.$api.post('/api/examecenter/apply', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                }
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/examecenter/centerdetail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormSuccess.vue?7a067f9c